<template>
  <CCard class="bg-style2">
    <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
      <span class="font-weight-bold h6">
        <CIcon name="cil-list-rich" class="mr-2"/>
        รายงานความต้องการหลักสูตรของส่วนการเจ้าหน้าที่
      </span>
      <div class="card-header-actions">
        <CButton
          size="sm"
          color="light"
          variant="outline"
          class="text-white border-white"
          @click="exportAll"
        >
          <CIcon name="cil-cloud-download" class="mr-1"/>
          Export Excel
        </CButton>
      </div>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :table-filter="{label:''}"
        :fields="fields"
        :items="items"
        :items-per-page="small ? 50 : 20"
        :dark="dark"
        :loading="loading"
        pagination
        :items-per-page-select="pages"
        sorter
      >
        <template #index="{index}">
          <td class="text-center">{{ index + 1 }}</td>
        </template>

        <template #courseTitle="{item}">
          <td>
            <div class="font-weight-bold">{{ item.courseTitle }}</div>
            <div class="small text-muted">{{ item.methodTitle }}</div>
          </td>
        </template>

        <template #totalPeople="{item}">
          <td class="text-center">{{ item.totalPeople }}</td>
        </template>

        <template #totalSelections="{item}">
          <td class="text-center">{{ item.totalSelections }}</td>
        </template>

        <template #totalAgencies="{item}">
          <td class="text-center">{{ item.totalAgencies }}</td>
        </template>

        <template #action="{item,index}">
          <td class="text-center" style="width: 160px">
            <CButton
              class="mr-1"
              size="sm"
              color="info"
              shape="pill"
              variant="outline"
              @click="toggleDetails(item, index)"
            >
              <CIcon name="cil-description"/>
            </CButton>
            <CButton
              size="sm"
              color="success"
              shape="pill"
              variant="outline"
              @click="exportCourse(item)"
            >
              <CIcon name="cil-cloud-download"/>
            </CButton>
          </td>
        </template>

        <template #details="{item}">
          <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
            <CCard class="bg-style mb-4 border-dark">
              <CCardHeader class="bg-gradient-dark text-white">
                <span class="font-weight-bold h6">
                  <CIcon name="cil-people" class="mr-2"/>
                  {{ item.courseTitle }}
                </span>
                <div class="card-header-actions">
                  รวม {{ item.items.length }} รายการ
                </div>
              </CCardHeader>
              <CCardBody>
                <CDataTable
                  :table-filter="{label:''}"
                  :fields="detailFields"
                  :items="item.items"
                  :items-per-page="small ? 50 : 10"
                  :dark="dark"
                  :loading="loading"
                  pagination
                  sorter
                >
                  <template #index="{index}">
                    <td class="text-center">{{ index + 1 }}</td>
                  </template>

                  <template #code="{item}">
                    <td class="text-center">{{ item.code || '-' }}</td>
                  </template>

                  <template #name="{item}">
                    <td>{{ item.name || '-' }}</td>
                  </template>

                  <template #agency="{item}">
                    <td>{{ item.agency || '-' }}</td>
                  </template>

                  <template #employmentStatus="{item}">
                    <td class="text-center">{{ item.employmentStatus || '-' }}</td>
                  </template>

                  <template #competency="{item}">
                    <td>
                      <div>{{ item.competency || '-' }}</div>
                      <div class="small text-muted">{{ item.competencyGroup || '-' }}</div>
                    </td>
                  </template>

                  <template #level="{item}">
                    <td class="text-center">{{ item.level || '-' }}</td>
                  </template>

                  <template #status="{item}">
                    <td class="text-center">{{ item.status || '-' }}</td>
                  </template>
                </CDataTable>
              </CCardBody>
            </CCard>
          </CCollapse>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "TrainingDemandCourses",
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    summary: {
      type: Object,
      default() {
        return {
          totalCourses: 0,
          totalSelections: 0,
          totalPeople: 0
        };
      }
    },
    year: {
      type: Number,
      default: null
    },
    small: Boolean,
    dark: Boolean,
    loading: Boolean,
    pages: {
      type: Object,
      default() {
        return {
          values:[10,20,50,100]
        }
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: "width:50px; text-align: center"},
          {key: "courseTitle", label: "หลักสูตร"},
          {key: "totalPeople", label: "จำนวนบุคลากร", _style: "width:140px; text-align: center"},
          {key: "totalSelections", label: "จำนวนการเลือก", _style: "width:140px; text-align: center"},
          {key: "totalAgencies", label: "จำนวนหน่วยงาน", _style: "width:140px; text-align: center"},
          {key: "action", label: "#", _style: "width:160px; text-align: center"}
        ];
      }
    },
    detailFields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: "width:50px; text-align: center"},
          {key: "code", label: "Code", _style: "width:100px; text-align: center"},
          {key: "name", label: "Name"},
          {key: "agency", label: "หน่วยงาน"},
          {key: "employmentStatus", label: "สถานภาพการทำงาน", _style: "width:180px; text-align: center"},
          {key: "competency", label: "สมรรถนะ"},
          {key: "level", label: "ระดับ", _style: "width:100px; text-align: center"},
          {key: "status", label: "สถานะ", _style: "width:140px; text-align: center"}
        ];
      }
    }
  },

  data: function () {
    return {
      collapseDuration: 0
    };
  },

  methods: {
    toggleDetails(item) {
      item._toggled = !item._toggled;
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },

    buildSummaryRows() {
      return this.items.map((item, index) => ({
        index: index + 1,
        course: item.courseTitle,
        method: item.methodTitle,
        totalPeople: item.totalPeople,
        totalSelections: item.totalSelections,
        totalAgencies: item.totalAgencies
      }));
    },

    buildDetailRows(rows) {
      return (rows || []).map((item, index) => ({
        index: index + 1,
        course: item.courseTitle,
        code: item.code,
        name: item.name,
        agency: item.agency,
        employmentStatus: item.employmentStatus,
        competencyGroup: item.competencyGroup,
        competency: item.competency,
        level: item.level,
        status: item.status
      }));
    },

    exportAll() {
      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.json_to_sheet(this.buildSummaryRows());
      const detailRows = this.items.flatMap((item) => this.buildDetailRows(item.items));
      const detailSheet = XLSX.utils.json_to_sheet(detailRows);

      XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");
      XLSX.utils.book_append_sheet(workbook, detailSheet, "Details");
      XLSX.writeFile(workbook, `training-demand-${this.year || "report"}.xlsx`);
    },

    exportCourse(item) {
      const workbook = XLSX.utils.book_new();
      const detailSheet = XLSX.utils.json_to_sheet(this.buildDetailRows(item.items));
      XLSX.utils.book_append_sheet(workbook, detailSheet, "Details");
      XLSX.writeFile(workbook, `${item.courseTitle || "course"}.xlsx`);
    }
  }
}
</script>

<style scoped>

</style>
